import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface CancelDayDialogProps {
  open: boolean;
  userName: string;
  date: string;
  appointmentCount: number;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const CancelDayDialog: React.FC<CancelDayDialogProps> = ({
  open,
  userName,
  date,
  appointmentCount,
  loading = false,
  onConfirm,
  onCancel,
}) => {
  const formattedDate = new Date(date).toLocaleDateString('de-DE', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="warning" />
        Tag absagen
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Möchten Sie den gesamten Tag am{' '}
          <strong>{formattedDate}</strong> absagen?
        </DialogContentText>
        {appointmentCount > 0 && (
          <DialogContentText sx={{ mt: 2, color: 'error.main' }}>
            ⚠️ <strong>{appointmentCount} Termin{appointmentCount !== 1 ? 'e' : ''}</strong> {appointmentCount !== 1 ? 'werden' : 'wird'} automatisch
            storniert.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit" disabled={loading}>
          Abbrechen
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error" autoFocus disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Tag absagen'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
